export default __webpack_public_path__ + "3e6b573a385b751cd850a059c2d8541d.png";